import React from 'react';

import { useLang } from 'hooks';
import { usePayoutsQuery } from 'hooks/queries';
import { CardView } from 'components/layout';

const PayoutsCard = () => {
  const lang = useLang();

  const payoutsQuery = usePayoutsQuery();

  return (
    <CardView
      title={lang.get('withdrawal.payouts.title')}
      caption={lang.choice('withdrawal.payouts.caption', payoutsQuery.data?.total || 0)}
      type="secondary"
    />
  );
};

export default PayoutsCard;
